import { render } from "./VacancyDetails.vue?vue&type=template&id=26ac3794&scoped=true"
import script from "./VacancyDetails.vue?vue&type=script&lang=js"
export * from "./VacancyDetails.vue?vue&type=script&lang=js"

import "./VacancyDetails.vue?vue&type=style&index=0&id=26ac3794&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26ac3794"]])

export default __exports__